module.exports = __webpack_public_path__ + "img/model4_ug.bc97bbcd.jpg";